import React from "react";

interface SettingsSectionProps {
  title: string;
  children?: React.ReactNode;
  comingSoon?: boolean;
}

export function SettingsSection({ title, children, comingSoon = false }: SettingsSectionProps) {
  return (
    <div>
      <h2 className="mb-3 text-lg text-gray-700 font-semibold">{title}</h2>
      {comingSoon ? (
        <p className="text-sm text-gray-500">{title} content coming soon...</p>
      ) : (
        children
      )}
    </div>
  );
}
